import { LIVE_DRAWING_SET_PATHS, LIVE_DRAWING_UPDATE_PATH } from './liveDrawingConstants';

export const setLiveDrawingPaths = ({ offset, paths, editedDrawingId, userId }) => ({
    type: LIVE_DRAWING_SET_PATHS,
    paths,
    editedDrawingId,
    userId,
    sync: true,
});

export const updateLiveDrawingPath = ({ path, userId }) => ({
    type: LIVE_DRAWING_UPDATE_PATH,
    path,
    userId,
    sync: true,
});
